export const TASKS_LOAD = 'TASKS_LOAD';
export const TASKS_LOAD_SUCCESS = 'TASKS_LOAD_SUCCESS';
export const TASKS_LOAD_ERROR = 'TASK_LOAD_ERROR';
export const TASKS_DELETE_COMPLETED = 'TASK_DELETE_COMPLETED';
export const TASKS_DELETE_COMPLETED_SUCCESS = 'TASK_DELETE_COMPLETED_SUCCESS';
export const TASKS_DELETE_COMPLETED_ERROR = 'TASK_DELETE_COMPLETED_ERROR';

export const TASK_LOAD_SUCCESS = 'TASKS_LOAD_SUCCESS';
export const TASK_LOAD_ERROR = 'TASK_LOAD_ERROR';
export const TASK_ADD = 'TASK_ADD';
export const TASK_ADD_SUCCESS = 'TASK_ADD_SUCCESS';
export const TASK_ADD_ERROR = 'TASK_ADD_ERROR';
